/**
 * Cursor-pagination state machine for the Holds table (util C).
 *
 * The wallet list API is cursor-based (`{ items, next_cursor }`) with no total
 * count, so there's no "page X of Y" or "Last" — only Prev/Next. This wraps the
 * cursor stack so the component template never mutates arrays directly.
 *
 *   const pager = createCursorPager();
 *   pager.cursor();            // null  → fetch first page
 *   pager.next(nextCursor);    // advance using the API's next_cursor
 *   pager.cursor();            // nextCursor → fetch next page
 *   pager.canPrev();           // true
 *   pager.prev();              // step back one page
 *   pager.reset();             // back to the first page (e.g. on filter change)
 *
 * @returns {{
 *   cursor: () => (string|null),
 *   canPrev: () => boolean,
 *   next: (nextCursor: string|null) => void,
 *   prev: () => void,
 *   reset: () => void,
 * }}
 */
export function createCursorPager() {
  // Cursors for pages we can navigate back to. `current` is the cursor used to
  // fetch the page on screen now (null === first page).
  let stack = [];
  let current = null;

  return {
    cursor() {
      return current;
    },

    canPrev() {
      return stack.length > 0;
    },

    next(nextCursor) {
      // No-op when there is no further page.
      if (nextCursor === null || nextCursor === undefined) return;
      stack.push(current);
      current = nextCursor;
    },

    prev() {
      if (stack.length === 0) return; // no-op at the first page
      current = stack.pop();
    },

    reset() {
      stack = [];
      current = null;
    },
  };
}
